import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import {Tab, Tabs, TabList, TabPanel}   from 'react-tabs';
import history from '../../utils/history';
import ReactTooltip                     from 'react-tooltip';
import UserManual                       from '../../styles/docs/FFT_DemoUserGuide.pdf';
import SettingsDialog                   from './SettingsDialog';
import TextControl                      from './TextControl';
import SegmentsControl                  from './SegmentsControl';
import SentimentControl                 from './SentimentControl';
import SummaryControl                   from './SummaryControl';
import HeadlineControl                  from './HeadlineControl';
import TagControl                       from './TagControl';
import urlHandler                       from '../../utils/urlHandler';
import session                          from '../../utils/session'
import filter                           from '../../utils/removeSubText';
import SegmentUtils                     from '../../utils/segment-utils';
import tagText                          from '../../utils/tag-text';
import _                              from 'underscore';
import settings                         from '../../utils/settings';
import TranslateControl                 from './TranslateControl';
import permissions                      from '../../utils/permissions';

class DemosControl extends Component {
    constructor(props){
        super(props);
        this.onTextChange = this.onTextChange.bind(this);
        this.onContextChange = this.onContextChange.bind(this);
        this.onConfidenceChange = this.onConfidenceChange.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onTabSelect = this.onTabSelect.bind(this);
        this.onLanguageChange = this.onLanguageChange.bind(this);
        this.onSettingsChange = this.onSettingsChange.bind(this);
        this.saveToLocal = this.saveToLocal.bind(this);

        this.doEnrichCall = this.doEnrichCall.bind(this);
        this.doSentimentCall = this.doSentimentCall.bind(this);
        this.doSummaryCall = this.doSummaryCall.bind(this);
        this.doTagCall = this.doTagCall.bind(this);
        this.doTranslateCall = this.doTranslateCall.bind(this);
        this.doHeadlineCall = this.doHeadlineCall.bind(this);

        this.state = {
            demoResults: this.props.results,
            activeDemo: 'entities',
            types: settings.getValue('types',[]),
            text: this.props.text || '',
            context: '',
            minConfidence: 0,
            originalText: '',
            informationExtraction: settings.getValue('informationExtraction', false) && !!Array.isArray(settings.getValue('informationExtractionTemplates', null)),
            sentimentModel: settings.getValue('sentimentModel', window._sentimentModel),
            languageCode: settings.getValue('languageCode', 'en'),
            languageVals: this.props.supportedLanguages,
            summaryLanguageVals: ['en','de','fr','es','nl'],
            headlineLanguageVals: ['en'],

            selectedTabIndex: 0
        }

        this.tabList = []; // List of tabs that are displayed
        this.tabListChanged = false; // Notification that tabs displayed have changed
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) { 
        if (nextProps.text != this.props.text) {
            if (!_.isEqual(nextProps.results, this.state.demoResults)) {
                this.setState({
                    text: nextProps.text,
                    originalText: nextProps.text,
                    demoResults: nextProps.results
                })
            } else {
                this.setState({
                    text: nextProps.text,
                    originalText: nextProps.text,
                })
            }
        } else {
            if (!_.isEqual(nextProps.results, this.state.demoResults)) {
                this.setState({
                    demoResults: nextProps.results
                })
            }       
        }

        if (!_.isEqual(nextProps.supportedLanguages, this.props.supportedLanguages)) {
            this.setState({
                languageVals: nextProps.supportedLanguages
            })
        }
    }

    componentWillUpdate(nextProps, nextState) {

        // Build a list of tabs to display in tab control
        var tempTabList = [];
        if (nextProps.permissions.entities) {
            tempTabList.push('entities');
        }
        if (nextProps.permissions.sentiment && nextState.languageCode === 'en' && nextState.sentimentModel != 'none') {
            tempTabList.push('sentiment');
        }
        if (nextProps.permissions.summary && this.state.summaryLanguageVals.includes(nextState.languageCode)) {
            tempTabList.push('summary');
        }
        if (nextProps.permissions.tag && nextState.languageCode === 'en') {
            tempTabList.push('tag');
        }
        if (nextProps.permissions.translate) {
            tempTabList.push('translate');
        }
        if (nextProps.permissions.generateHeadline) {
            tempTabList.push('headline');
        }

        // If tabs have changed, note that
        if (this.tabList.length > 0 && (this.tabList.length != tempTabList.length)) {
            this.tabListChanged = true;
        }

        this.tabList = tempTabList;
    }

    componentDidUpdate() {

        // If the tabs have changed (hidden sentiment, etc), then auto select the first tab as it's left in weird state
        if (this.tabListChanged) {
            this.setState({
                selectedTabIndex: 0
            },() => {
                this.onTabSelect(0);
            });
            this.tabListChanged = false;
        }
    }

    onTextChange(text) {
        this.setState({
            text,
            originalText: text,
            demoResults: {
                // entityData: null,
                // entities: {
                //     json: null,
                //     entities: null,
                //     segments: null,
                //     keyPhrases: null,
                //     keyPhraseWeights: null,
                //     topicVector: null,
                //     industries: null,
                //     relationships: null,
                //     salience: null
                // },
                // sentiment: {
                //     json: null
                // },
                // summary: {
                //     json: null
                // },
                // tag: {
                //     json: null,
                //     tags: null
                // },
                // translate: {
                //     json: null
                // },
                // headline: {
                //     json: null
                // }
            }
        },() => {
            if (this.props.onTextChange) {
                this.props.onTextChange(text);
            }
        })
    }

    onContextChange(text) {
        console.log('setting context => ', text);
        this.setState({
            context: text
        })
    }

    onSettingsChange(setting) {
        if (setting === 'sentimentModel') {
            this.setState((prevState) => {
                const demoResults = Object.assign({},prevState.demoResults)
                // Sentiment model has changed so sentiment results are dirty
                delete demoResults['sentiment']
                return {
                    sentimentModel: settings.getValue('sentimentModel', window._sentimentModel),
                    demoResults
                    // demoResults: {
                    //     entityData: prevState.demoResults.entityData,
                    //     entities: prevState.demoResults.entities,
                    //     sentiment: {
                    //         json: null
                    //     },
                    //     summary: prevState.demoResults.summary,
                    //     tag: prevState.demoResults.tag,
                    //     translate: prevState.demoResults.translate,
                    //     headline: prevState.demoResults.headline
                    // }
                }
            }, () => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.demoResults);
                }
            });
        }
        if (setting === 'informationExtraction'){
            this.setState({'informationExtraction': settings.getValue('informationExtraction', false) && !!Array.isArray(settings.getValue('informationExtractionTemplates', null))})//, () => this.onSettingsChange('types'))
        }

        if (setting === 'types' && this.state.demoResults && this.state.demoResults.entities && 
            this.state.demoResults.entities.json && this.state.demoResults.entities.json.entities&& this.state.demoResults.entities.entities){
            let perms = permissions.getAll();
            let entityVals = perms && perms['entities'] || [];
            let types = settings.getValue('types',[]).filter((t)=>t.selected).map((t)=>t.name);

            // If the option is available to include the entitytype and it is excluded then drop
            let filtered_entities = this.state.demoResults.entities.json.entities.filter((ent)=> 
                // only include entities type is explicitly included, or where the type is custom and OTHER types are included or IE is enabled
                types.includes(ent.type) || (!entityVals.includes(ent.type) && ((types.includes('OTHER') || this.state.informationExtraction)))
            );
            var orig_segments = SegmentUtils.convertEntitiesToSegments(filtered_entities);
            var segments = SegmentUtils.withMinConfidence(filter(orig_segments), SegmentUtils.minConfidence(filter(orig_segments)));
            
            let newState= Object.assign({},this.state,
                {types: settings.getValue('types',[])},
                {minConfidence: SegmentUtils.minConfidence(filter(orig_segments))},
                {demoResults: Object.assign({},this.state.demoResults,
                    {entities: Object.assign({},this.state.demoResults.entities, 
                        {entities: filter(orig_segments), segments: tagText(this.state.text, segments)})
                    }
                )}
            )
            this.setState(newState,() => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.demoResults);
                }
            });
        }
    }

    onReset(e) {
        e.preventDefault();
        this.setState({
            demoResults: {
                // entityData: null,
                // entities: {
                //     json: null,
                //     entities: null,
                //     segments: null,
                //     keyPhrases: null,
                //     keyPhraseWeights: null,
                //     topicVector: null,
                //     industries: null,
                //     relationships: null,
                //     salience: null
                // },
                // sentiment: {
                //     json: null
                // },
                // summary: {
                //     json: null
                // },
                // tag: {
                //     json: null,
                //     tags: null
                // },
                // translate: {
                //     json: null
                // },
                // headline: {
                //     json: null
                // }
            },
            text: '',
            originalText: '',
            context: ''
        },() => {
            if (this.props.onTextChange) {
                this.props.onTextChange('');
            }
            if (this.props.onChange) {
                this.props.onChange(this.state.demoResults)
            }
        })
    }

    onEdit(e) {
        console.log('context => ', this.state.context);
        e.preventDefault();
        this.setState({
            demoResults: {
                // entityData:null,
                // entities: {
                //     json: null,
                //     entities: null,
                //     segments: null,
                //     keyPhrases: null,
                //     keyPhraseWeights: null,
                //     topicVector: null,
                //     industries: null,
                //     relationships: null,
                //     salience: null
                // },
                // sentiment: {
                //     json: null
                // },
                // summary: {
                //     json: null
                // },
                // tag: {
                //     json: null,
                //     tags: null
                // },
                // translate: {
                //     json: null
                // },
                // headline: {
                //     json: null
                // }
            },
            text: this.state.originalText,
            context: this.state.context
        },() => {
            if (this.props.onChange) {
                this.props.onChange(this.state.demoResults);
            }
        })
    }

    onTabSelect(index) {
        var selectedDemo = this.tabList[index];
        this.setState({
            selectedTabIndex: index,
            activeDemo: selectedDemo
        }, () => {
            if (this.props.onDemoChange) {
                this.props.onDemoChange(selectedDemo)
            }
        })
    }

    onLanguageChange(lang) {
        this.setState({
            languageCode: lang
        })
    }

    saveToLocal (text) {

        var maxDocs = window._maxRecentDocs - 1;

        // as the doc was successfully enriched, cache it for quick access
        const textPreview = text.length > 86 ? text.substring(0,86) + '...' : text;
        let i;
    
        let recentDocs = JSON.parse(localStorage.getItem('recentDocuments'));

        // if the doc has already been enriched, just return
        for (i = 0; i < recentDocs.length; i++) {
            if (recentDocs[i].text === text) {
                return;
            }
        }

        // ensure we never have more than 12 recent docs
        if (recentDocs.length > maxDocs) {
            recentDocs = recentDocs.splice(recentDocs.length - maxDocs, maxDocs);
        }
    
        recentDocs.push({
            preview: textPreview,
            text
        });
        localStorage.setItem('recentDocuments', JSON.stringify(recentDocs));
    };

    onConfidenceChange(value) {
        var orig_segments = this.state.demoResults.entities.entities;
        var segments = SegmentUtils.withMinConfidence(filter(orig_segments), value);

        const demoResults = Object.assign({},this.state.demoResults)
        demoResults.entities =  {
            json: this.state.demoResults.entities.json,
            entities: filter(orig_segments),
            segments: tagText(this.state.text, segments),
            keyPhrases: this.state.demoResults.entities.keyPhrases || [],
            keyPhraseWeights: this.state.demoResults.entities.keyPhraseWeights || [],
            topicVector: this.state.demoResults.entities.topicVector || {},
            industries: this.state.demoResults.entities.industries
        };

        this.setState({
            // demoResults: {
            //     entityData: this.state.demoResults.entityData,
            //     entities: {
            //         json: this.state.demoResults.entities.json,
            //         entities: filter(orig_segments),
            //         segments: tagText(this.state.text, segments),
            //         keyPhrases: this.state.demoResults.entities.keyPhrases || [],
            //         keyPhraseWeights: this.state.demoResults.entities.keyPhraseWeights || [],
            //         topicVector: this.state.demoResults.entities.topicVector || {},
            //         industries: this.state.demoResults.industries
            //     },
            //     sentiment: this.state.demoResults.sentiment,
            //     summary: this.state.demoResults.summary,
            //     tag: this.state.demoResults.tag,
            //     translate: this.state.demoResults.translate,
            //     headline: this.state.demoResults.headline
            // },
            demoResults,
            minConfidence: value
        },() => {
            if (this.props.onChange) {
                this.props.onChange(this.state.demoResults);
            }
        });
    }

    doEnrichCall(text, options) {    
        let entitiesOrtext = options.informationExtraction ? urlHandler.convertDoc2({text}).then((res)=>res.data) : Promise.resolve(text);
        entitiesOrtext.then((resolve)=>{
            urlHandler.sendRequest('enrich','sandbox','',resolve, options, (response, ret_text) => {
                if (response.error_status) {
                    history.push('/error/' + response.error_status + '/' + response.error_message);
                    return;
                } else {

                    // The enrich call now uses the V2 format. In order to prevent having to
                    // re-architect the bulk of the underlying structures that use the old
                    // V1 "segments" format, convert the new "entities" portion of the response to the
                    // older "segments" format.

                    let perms = permissions.getAll();
                    let entityVals = perms && perms['entities'] || [];
                    let types = settings.getValue('types',[]).filter((t)=>t.selected).map((t)=>t.name);
                    const raw_entities = response.entities ? response.entities : [];
                    // If the option is available to include the entitytype and it is excluded then drop
                    let filtered_entities =  raw_entities.filter((ent)=> 
                        // only include entities type is explicitly included, or where the type is custom and OTHER types are included or IE is enabled
                        types.includes(ent.type) || (!entityVals.includes(ent.type) && (types.includes('OTHER') || options.informationExtraction))
                    );

                    var orig_segments = SegmentUtils.convertEntitiesToSegments(filtered_entities);
                    var segments = SegmentUtils.withMinConfidence(filter(orig_segments), SegmentUtils.minConfidence(filter(orig_segments)));
                    // Use the returned text from enrich call (if available)
                    var originalText = text;
                    if ('text' in response) {
                        if (this.props.onTextChange) {
                            // if text variable is changed ensure it does not cause entity misalignment
                            text = response.text;
                            this.props.onTextChange(response.text);
                        }
                    }
                    if (orig_segments.length > 0) {
                        this.saveToLocal(originalText);
                    }

                    // need to add in calls to fetch entityData here
                    const demoResults = Object.assign({},this.state.demoResults)
                    demoResults.entities =  {
                        json: response,
                        entities: filter(orig_segments),
                        segments: tagText(text, segments),
                        keyPhrases: response.keyPhrases || [],
                        keyPhraseWeights: response.keyPhraseWeights || [],
                        topicVector: response.topicVector || {},
                        industries: 'industries' in response ? response.industries : null,
                        relationships: 'relationships' in response && response.relationships.length > 0 ? response.relationships : null,
                        salience: 'salience' in response ? response.salience : null
                    };
                    const disambiguated_entities = response.entities.filter((e)=>e.disambiguated && e.disambiguated.id)
                    // const disam_id = disambiguated_entities[0].disambiguated.id
                    // console.log(disam_id)
                    // console.log(`${window._FFT_webServiceUrl}`)
                    // console.log(`${window._FFT_webServiceUrl}/api/v2/entities/${disam_id}`)
                    // console.log(`${session.getToken()}`)
                    // console.log('osdhfosiadjfoiasjdfoisadjfosaidjfaosidjfasoidfjosifdosiafj')
                    // fetch(`${window._FFT_webServiceUrl}/api/v2/entities/${disam_id}`, {
                    //     method: 'GET',
                    //     headers: {
                    //         'Authorization': `Bearer ${session.getToken()}`
                    //     }
                    // })
                    // .then((response) => response.json())
                    // .then((data) => console.log(data))
                    // .catch((error) => console.error('Error:', error));
                    Promise.all(disambiguated_entities.map((e)=>{
                        return fetch(`${window._FFT_webServiceUrl}/api/v2/entities/${e.disambiguated.id}`, {
                            method: 'GET',
                            headers: {
                                'Authorization': `Bearer ${session.getToken()}`
                            }
                        })
                        .then((response) => response.json())
                        .catch((error) => console.error('Error:', error));
                    }))
                    .then((data) => {
                        const entitiesData = data.reduce((acc, curr) => {
                            acc[curr.id] = curr;
                            return acc;
                        }, {});
                        demoResults.entitiesData = entitiesData;
                        this.setState({
                            demoResults,
                            text,
                            originalText,
                            minConfidence: SegmentUtils.minConfidence(filter(orig_segments))
                        },() => {
                            if (this.props.onChange) {
                                this.props.onChange(this.state.demoResults);
                            }
                        });
                    })

                    
    
    
                    // request.send();

                    // urlHandler.sendRequest('entities2', null, entities[0].disambiguationResults[0].id, null, null, (response,txt,status) => {
                    //     if (status == 200) {

                            

                    //     }
                    // })

                    // this.setState({
                    //     demoResults: {
                    //         entities: {
                    //             json: response,
                    //             entities: filter(orig_segments),
                    //             segments: tagText(text, segments),
                    //             keyPhrases: response.keyPhrases || [],
                    //             keyPhraseWeights: response.keyPhraseWeights || [],
                    //             topicVector: response.topicVector || {},
                    //             industries: 'industries' in response ? response.industries : null,
                    //             relationships: 'relationships' in response && response.relationships.length > 0 ? response.relationships : null,
                    //             salience: 'salience' in response ? response.salience : null
                    //         },
                    //         sentiment: this.state.demoResults.sentiment,
                    //         summary: this.state.demoResults.summary,
                    //         tag: this.state.demoResults.tag,
                    //         translate: this.state.demoResults.translate,
                    //         headline: this.state.demoResults.headline
                    //     },
                    //     demoResults,
                    //     text,
                    //     originalText,
                    //     minConfidence: SegmentUtils.minConfidence(filter(orig_segments))
                    // },() => {
                    //     if (this.props.onChange) {
                    //         this.props.onChange(this.state.demoResults);
                    //     }
                    // });
                }
            });
        });
    }

    doSentimentCall(text, sentimentModel) {
        urlHandler.sendDocSentimentRequest(text, sentimentModel, 'en', (response, status) => {
            if (response.error_status) {
                history.push('/error/' + response.error_status + '/' + response.error_message);
                return;
            } else {

                if (response.sentiment) {
                    this.saveToLocal(text);
                }
                const demoResults = Object.assign({},this.state.demoResults)
                demoResults.sentiment = {
                    json: response.sentiment || {}
                };
                this.setState({
                    // demoResults: {
                    //     entities: this.state.demoResults.entities,
                    //     sentiment: {
                    //         json: response.sentiment || {}
                    //     },
                    //     summary: this.state.demoResults.summary,
                    //     tag: this.state.demoResults.tag,
                    //     translate: this.state.demoResults.translate,
                    //     headline: this.state.demoResults.headline
                    // },
                    demoResults,
                    originalText: text
                },() => {
                    if (this.props.onChange) {
                        this.props.onChange(this.state.demoResults);
                    }
                })  
            }
        });
    }

    doSummaryCall(text, summaryModel, languageCode) {
        urlHandler.sendSummarizeRequest(text, summaryModel, languageCode, (response, status) => {
            if (response.error_status) {
                history.push('/error/' + response.error_status + '/' + response.error_message);
                return;
            } else {

                if (response) {
                    this.saveToLocal(text);
                }
                const demoResults = Object.assign({},this.state.demoResults)
                demoResults.summary= {
                    json: response
                };

                this.setState({
                    // demoResults: {
                    //     entities: this.state.demoResults.entities,
                    //     sentiment: this.state.demoResults.sentiment,
                    //     summary: {
                    //         json: response
                    //     },
                    //     tag: this.state.demoResults.tag,
                    //     translate: this.state.demoResults.translate,
                    //     headline: this.state.demoResults.headline
                    // },
                    demoResults,
                    originalText: text
                },() => {
                    if (this.props.onChange) {
                        this.props.onChange(this.state.demoResults);
                    }
                })  
            }
        });
    }

    doTagCall(text, tagModel, posThreshold, negThreshold, maxTags) {
        urlHandler.sendTagRequest(text, tagModel, 'en', posThreshold, negThreshold, maxTags, (response, status) => {
            if (response.error_status) { 
                history.push('/error/' + response.error_status + '/' + response.error_message);
                return;
            } else {

                // Get the tags for this tagmodel
                var tags = [];
                if ('tagResults' in response) {
                    var model = response.tagResults.find((m) => { return m.model == tagModel });
                    if (model) {
                        tags = model.tags;
                    }
                }

                // Sort the tags by score
                var res = tags.sort(function(a, b) {
                    return ((a.score > b.score) ? -1 : ((a.score == b.score) ? 0 : 1));
                }).filter(function(tag) {
                    return tag.score > 0.0;
                })

                if (response) {
                    this.saveToLocal(text);
                }
                const demoResults = Object.assign({},this.state.demoResults)
                demoResults.tag = {
                    json: response,
                    tags: res
                };
                this.setState({
                    // demoResults: {
                    //     entities: this.state.demoResults.entities,
                    //     sentiment: this.state.demoResults.sentiment,
                    //     summary: this.state.demoResults.summary,
                    //     tag: {
                    //         json: response,
                    //         tags: res
                    //     },
                    //     translate: this.state.demoResults.translate,
                    //     headline: this.state.demoResults.headline
                    // },
                    demoResults,
                    originalText: text
                },() => {
                    if (this.props.onChange) {
                        this.props.onChange(this.state.demoResults);
                    }
                })  
            }
        });
    }

    doTranslateCall(text, format, targetLanguage, sourceLanguage) {
        console.log('doTranslateCall => ', text, format, targetLanguage, sourceLanguage);
        urlHandler.translateText(text, format, targetLanguage, sourceLanguage, (response, status) => {
            if (response.error_status) { 
                history.push('/error/' + response.error_status + '/' + response.error_message);
                return;
            } else {

                if (response) {
                    this.saveToLocal(text);
                }
                const demoResults = Object.assign({},this.state.demoResults)
                demoResults.translate = {
                    json: response
                };
                this.setState({
                    // demoResults: {
                    //     entities: this.state.demoResults.entities,
                    //     sentiment: this.state.demoResults.sentiment,
                    //     summary: this.state.demoResults.summary,
                    //     tag: this.state.demoResults.tag,
                    //     translate: {
                    //         json: response
                    //     },
                    //     headline: this.state.demoResults.headline
                    // },
                    demoResults,
                    originalText: text
                },() => {
                    if (this.props.onChange) {
                        this.props.onChange(this.state.demoResults);
                    }
                })  
            }
        });
    }

    doHeadlineCall(text, languageCode) {
        urlHandler.generateHeadline(text, languageCode, (response, status) => {
            if (response.error_status) { 
                history.push('/error/' + response.error_status + '/' + response.error_message);
                return;
            } else {

                if (response) {
                    this.saveToLocal(text);
                }
                const demoResults = Object.assign({},this.state.demoResults)
                demoResults.headline = {
                    json: response
                };
                this.setState({
                    // demoResults: {
                    //     entities: this.state.demoResults.entities,
                    //     sentiment: this.state.demoResults.sentiment,
                    //     summary: this.state.demoResults.summary,
                    //     tag: this.state.demoResults.tag,
                    //     translate: this.state.demoResults.translate,
                    //     headline: {
                    //         json: response
                    //     }
                    // },
                    demoResults,
                    originalText: text
                },() => {
                    if (this.props.onChange) {
                        this.props.onChange(this.state.demoResults);
                    }
                })  
            }
        });
    }

    render() {    
        var forceEnglish = settings.getValue('forceEnglish', true);
        let selectedTypeNames = this.state.types.filter((t)=>t.selected).map((t)=>t.name)
        if(!selectedTypeNames.includes('OTHER') && this.state.informationExtraction){
            selectedTypeNames.push('OTHER');
        }
        const selectedTypes = selectedTypeNames.map((t)=>({name:t, selected:true}));
        
        return (
            <div>
                <div>
                    <span className="demoscontrol-toolbar">
                        <a href={ UserManual } target="__blank" download="FFT_DemoUserManual.pdf"> 
                            <span className='fa fa-file-pdf-o'>&nbsp;</span> 
                            User Manual 
                        </a> 
                        <button style={{marginLeft:'15px'}} className="link-button"> 
                            <SettingsDialog onChange={this.onSettingsChange} permissions={this.props.permissions}/>
                        </button> 
                    </span>
                </div>
                <Tabs onSelect={this.onTabSelect} selectedIndex={this.state.selectedTabIndex}>
                    <TabList>
                        {this.props.permissions.entities &&
                        <Tab data-tip data-for="entities-tip">Entities
                            <ReactTooltip id="entities-tip" type="dark" effect="solid" place="top">
                                View results of Entity Extraction and Resolution
                            </ReactTooltip>
                        </Tab>
                        }
                        {(this.props.permissions.sentiment && this.state.languageCode === 'en' && this.state.sentimentModel != 'none') &&
                        <Tab data-tip data-for="sentiment-tip">Sentiment
                            <ReactTooltip id="sentiment-tip" type="dark" effect="solid" place="top">
                                View results of Sentence and Document Sentiment
                            </ReactTooltip>
                        </Tab>
                        }
                        {(this.props.permissions.summary && this.state.summaryLanguageVals.includes(this.state.languageCode)) &&
                        <Tab data-tip data-for="summary-tip">Summary
                            <ReactTooltip id="summary-tip" type="dark" effect="solid" place="top">
                                View results of Document Summarization
                            </ReactTooltip>
                        </Tab>
                        }
                        {(this.props.permissions.tag && this.state.languageCode === 'en') &&
                        <Tab data-tip data-for="tag-tip">Tag
                            <ReactTooltip id="tag-tip" type="dark" effect="solid" place="top">
                                View Custom Tag results based on Interest Areas
                            </ReactTooltip>
                        </Tab>
                        }
                        {(this.props.permissions.translate) &&
                        <Tab data-tip data-for="translate-tip">Translate
                            <ReactTooltip id="translate-tip" type="dark" effect="solid" place="top">
                                Translate text between languages
                            </ReactTooltip>
                        </Tab>
                        }
                        {(this.props.permissions.generateHeadline && this.state.languageCode === 'en') &&
                        <Tab data-tip data-for="headline-tip">Headline
                            <ReactTooltip id="headline-tip" type="dark" effect="solid" place="top">
                                View results of headline generation
                            </ReactTooltip>
                        </Tab>
                        }
                    </TabList>

                    {this.props.permissions.entities &&
                    <TabPanel>
                        {this.state.demoResults.entities && this.state.demoResults.entities.entities ?
                            <SegmentsControl segments={this.state.demoResults.entities.segments} 
                                entitiesData={this.state.demoResults.entitiesData}
                                onConfidenceFilterChange={this.onConfidenceChange}
                                minConfidence={this.state.minConfidence}
                                results={this.state.demoResults.entities.entities}
                                text={this.state.text}
                                types={selectedTypes}
                                originalText={this.state.originalText}
                                json={this.state.demoResults.entities.json}
                                onReset={this.onReset}
                                onEdit={this.onEdit}
                                languageCode={this.state.languageCode}
                            />
                        :
                            <TextControl text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text} 
                                onEnrich={this.doEnrichCall} 
                                submitText="Show Entities" 
                                onChange={this.onTextChange}
                                permissions={this.props.permissions}
                                onLanguageChange={this.onLanguageChange}
                                onContextChange={this.onContextChange}
                                context={this.state.context}
                                supportedLanguages={this.state.languageVals}
                            />
                        }
                    </TabPanel>
                    }
                    {(this.props.permissions.sentiment && this.state.languageCode === 'en' && this.state.sentimentModel != 'none') &&
                    <TabPanel>
                        {this.state.demoResults.sentiment && this.state.demoResults.sentiment.json ?
                            <SentimentControl 
                                text = {this.state.text}
                                class = {this.state.demoResults.sentiment.json.class || 'neutral'}
                                classConfidence = {this.state.demoResults.sentiment.json.classConfidence || 0}
                                score = {this.state.demoResults.sentiment.json.score ? this.state.demoResults.sentiment.json.score : 0} 
                                sentences = {this.state.demoResults.sentiment.json.sentences}
                                onReset={this.onReset}
                                onEdit={this.onEdit}
                            />
                        :
                            <TextControl text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text} 
                                onSentiment={this.doSentimentCall} 
                                submitText="Show Sentiment" 
                                onChange={this.onTextChange}
                                permissions={this.props.permissions}
                            />
                        }
                    </TabPanel>
                    }
                    {this.props.permissions.summary && this.state.summaryLanguageVals.includes(this.state.languageCode) &&
                    <TabPanel>
                        {this.state.demoResults.summary && this.state.demoResults.summary.json ?
                            <SummaryControl 
                                text = {forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text}
                                summary = {this.state.demoResults.summary.json}
                                onReset={this.onReset}
                                onEdit={this.onEdit}
                            />
                        :
                            <TextControl text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text} 
                                onSummary={this.doSummaryCall} 
                                submitText="Show Summary" 
                                onChange={this.onTextChange}
                                permissions={this.props.permissions}
                                onLanguageChange={this.onLanguageChange}
                                supportedLanguages={this.state.summaryLanguageVals}
                            />
                        }
                    </TabPanel>
                    }
                    {(this.props.permissions.tag && this.state.languageCode === 'en') &&
                    <TabPanel>
                        {this.state.demoResults.tag && this.state.demoResults.tag.tags ?
                            <TagControl 
                                text = {this.state.text}
                                onReset={this.onReset}
                                onEdit={this.onEdit}
                            />
                        :
                            <TextControl text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text} 
                                onTag={this.doTagCall} 
                                submitText="Show Tags" 
                                onChange={this.onTextChange}
                                permissions={this.props.permissions}
                            />
                        }
                    </TabPanel>
                    }
                    {(this.props.permissions.translate) &&
                    <TabPanel>
                        {this.state.demoResults.translate && this.state.demoResults.translate.json ?
                            <TranslateControl
                                text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text}
                                onReset={this.onReset}
                                onEdit={this.onEdit}
                                results={this.state.demoResults.translate.json}/>
                        :
                            <TextControl text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text} 
                                onTranslate={this.doTranslateCall} 
                                submitText="Show Translation" 
                                onChange={this.onTextChange}
                                permissions={this.props.permissions}
                                onLanguageChange={this.onLanguageChange}
                            />
                        }
                    </TabPanel>
                    }
                    {(this.props.permissions.generateHeadline && this.state.languageCode === 'en') &&
                    <TabPanel>
                        {this.state.demoResults.headline && this.state.demoResults.headline.json ?
                            <HeadlineControl
                                text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text}
                                onReset={this.onReset}
                                onEdit={this.onEdit}
                                results={this.state.demoResults.headline.json}/>
                        :
                            <TextControl text={forceEnglish && this.state.originalText.length > 0 ? this.state.originalText : this.state.text} 
                                onHeadline={this.doHeadlineCall} 
                                submitText="Show Headline" 
                                onChange={this.onTextChange}
                                permissions={this.props.permissions}
                                onLanguageChange={this.onLanguageChange}
                                supportedLanguages={this.state.headlineLanguageVals}
                            />
                        }
                    </TabPanel>
                    }
                </Tabs>
            </div>
        );
    }
}

DemosControl.defaultProps = {
    supportedLanguages: []
}

DemosControl.propTypes = {
    text: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onTextChange: PropTypes.func,
    onDemoChange: PropTypes.func,
    supportedLanguages: PropTypes.array,
    permissions: PropTypes.object.isRequired,
    results: PropTypes.object.isRequired
};

export default DemosControl;
